import { useTranslation } from 'react-i18next';
import React from 'react';
import { connect } from 'react-redux';
import {
  hide,
  del as deleteOrganizacion,
} from '../../../store/organizaciones/deleteOrganizacionModule';

import { AppDispatch, RootState } from '../../../store/store';
import { UUID } from '../../../types/standard';
import Button from '../../common/Buttons/Button/Button';
import Loading from '../../common/Loading/Loading';
import Modal from '../../common/Modal/Modal';
import styles from '../changeActions.module.scss';
import { ReactComponent as IconTrash } from '../../../assets/moreMenu/trash.svg';
import ButtonsGroup from '../../common/Buttons/ButtonsGroup/ButtonsGroup';
import renderWhen from '../../../helpers/renderWhen';
import { Organizacion } from '../../../types/organizaciones/organizacion';
import {
  selectDeleteOrganizacion,
  selectDeleteOrganizacionActive,
  selectDeleteOrganizacionLoading,
} from '../../../store/organizaciones/selectors';

interface DeleteOrganizacionProps {
  organizacion: Organizacion | null;
  active: boolean;
  loading: boolean;
  closeModal: () => void;
  deleteOrganizacion: (id: UUID) => void;
}

const DeleteOrganizacion: React.FC<DeleteOrganizacionProps> = ({
  organizacion,
  active,
  loading,
  closeModal,
  deleteOrganizacion,
}) => {
  const { t } = useTranslation();
  // 'active' controls if the modal is open or close
  if (!active) return null;
  return (
    <>
      {organizacion && (
        <Modal closeModal={closeModal}>
          <div className={styles.container}>
            <h1 className={styles.title}>
              <IconTrash className={`${styles.icon} ${styles.isIconTrash}`} />
              {t(
                'ComponentsPopupActionsDeleteOrganizacionDeleteOrganizacionEliminarOrganizacion',
              )}
            </h1>
            <p className={styles.description}>
              {t(
                'ComponentsPopupActionsDeleteOrganizacionDeleteOrganizacionEstasSeguroDeQuererEliminarLaOrganizacion',
              )}
            </p>
            <div className={styles.appointmentWrapper}>
              <div className={styles.description}>
                <p>
                  <span className={styles.appointmentSection}>
                    {t(
                      'ComponentsPopupActionsDeleteOrganizacionDeleteOrganizacionNombre',
                    )}
                    :
                  </span>
                  {organizacion.nombre}
                </p>
                <p>
                  <span className={styles.appointmentSection}>
                    {t(
                      'ComponentsPopupActionsDeleteOrganizacionDeleteOrganizacionPoblacion',
                    )}
                    :
                  </span>
                  {organizacion.entidad_principal?.poblacion}
                </p>
                <p>
                  <span className={styles.appointmentSection}>
                    {t(
                      'ComponentsPopupActionsDeleteOrganizacionDeleteOrganizacionCodigoPostal',
                    )}
                    :
                  </span>
                  {organizacion.entidad_principal?.codigo_postal}
                </p>
                <p>
                  <span className={styles.appointmentSection}>
                    {t(
                      'ComponentsPopupActionsDeleteOrganizacionDeleteOrganizacionProvinicia',
                    )}
                    :
                  </span>
                  {organizacion.entidad_principal?.provincia}
                </p>
              </div>
            </div>
            <ButtonsGroup variant="center">
              <Button type="button" variant="negative" onClick={closeModal}>
                {t('CommonCancelar')}
              </Button>
              <Button
                variant="positive"
                onClick={() => {
                  deleteOrganizacion(organizacion.id);
                  closeModal();
                }}
                data-testid="submit_button"
              >
                {t('CommonEliminar')}
              </Button>
            </ButtonsGroup>
            {loading && <Loading />}
          </div>
        </Modal>
      )}
    </>
  );
};

const ConnectedDeleteOrganizacion = connect(
  (state: RootState) => ({
    organizacion: selectDeleteOrganizacion(state),
    active: selectDeleteOrganizacionActive(state),
    loading: selectDeleteOrganizacionLoading(state),
  }),
  (dispatch: AppDispatch) => ({
    deleteOrganizacion: (payload: UUID) =>
      dispatch(deleteOrganizacion(payload)),
    closeModal: () => dispatch(hide()),
  }),
)(DeleteOrganizacion);

export default renderWhen(
  ConnectedDeleteOrganizacion,
  selectDeleteOrganizacionActive,
);
